import { createDispatchFunction } from 'shared/helpers';
import partial from 'lodash/partial';
import findIndex from 'lodash/findIndex';
import { unionBy, isEmpty } from 'lodash';
import TcEventService from './TcEventService';
import { LOCATION_STATUS, LOCATION_EVENT_STATUS } from '/shared/constants';

// Actions
const GET_TEST_CENTER_EVENT = 'tcEvent/GET_TEST_CENTER_EVENT';
const GET_EVENTS_BY_ID = 'tcEvent/GET_EVENTS_BY_ID';
const GET_TASKS = 'tcEvent/GET_TASKS';
const GET_ROOMS = 'tcEvent/GET_ROOMS';
const GET_ROOMS_DTO = 'tcEvent/GET_ROOMS_DTO';
const DELETE_ROOM = 'tcEvent/DELETE_ROOM';
const GET_TEST_CENTER_CYCLE = 'tcEvent/GET_TEST_CENTER_CYCLE';
const GET_EVENT_TCS_BY_ID = 'testCenter/GET_TCS_BY_ID';
const SET_ROOM_MANUAL_TIMER = 'tcEvent/SET_ROOM_MANUAL_TIMER';
const GET_ALL_ROOMS_DTO = 'tcEvent/GET_ALL_ROOMS_DTO';
const GET_TC_INFO = 'tcEvent/GET_TC_INFO';
const GET_DEVICES_CHECK_COUNT = 'tcEvent/GET_DEVICES_CHECK_COUNT';
const REVIEW_EVENT_CHECKOUT = 'tcEvent/REVIEW_EVENT_CHECKOUT';

const initialState = {
  currentEvent: {},
  eventLocations: [],
  allEventLocations: [],
  userEvents: [],
  loadingUserEvents: false,
  testCenterCycle: {},
  rooms: [],
  roomsDTO: [],
  locations: [],
  manualTimerFlags: {},
  tasks: [],
  testCenters: [],
  tcLoading: false,
  errorDeleteRoom: false,
  allRoomsDTO: [],
  tcInfo: {},
  devicesCheckCount: 0,
  loadingRoomsDTO: false,
  manualTimerSet: false,
};

const filterLocations = (locations, eventLocations, allLocations=false) => {
  if (!locations || (locations && !locations.length) ||
    !eventLocations || (eventLocations && !eventLocations.length)) {
    return [];
  }

  return locations.filter((data) => {
    const location = eventLocations.find(element => element.locationId === data.id);
    if (!location) {
      return false;
    }
    data.locationEvent = location;
    if (allLocations) {
      return location.locationId === data.id
    }
    return location.locationId === data.id && location.status !== LOCATION_EVENT_STATUS.closed && data.locationStatus.status !== LOCATION_STATUS.closed ;
  });
};


// Reducer
export default function tcEventReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_TEST_CENTER_EVENT:
      return {
        ...state,
        currentEvent: action.result.data || {},
        testCenterCycle: {},
        eventLocations: [],
        allEventLocations: [],
      };
    case GET_ROOMS:
      return {
        ...state,
        rooms: action.result.data || [],
        loadingRooms: action.result.loading,
      };
    case GET_ROOMS_DTO:
      return {
        ...state,
        roomsDTO: action.result.data || [],
        loadingRoomsDTO: action.result.loading,
      };
    case GET_ALL_ROOMS_DTO:
      return {
        ...state,
        allRoomsDTO: action.result.data || [],
      };
    case GET_TASKS:
      return {
        ...state,
        tasks: action.result.data || [],
      };
    case GET_TEST_CENTER_CYCLE:
      return {
        ...state,
        testCenterCycle: action.result.data || {},
        eventLocations: filterLocations(
          action.result.data && action.result.data.locations,
          state.currentEvent.locationEvents
        ) || [],
        allEventLocations: filterLocations(
          action.result.data && action.result.data.locations,
          state.currentEvent.locationEvents,
          true,
        ) || [],
      };
    case GET_EVENTS_BY_ID:
      return {
        ...state,
        userEvents: action.result.data,
        loadingUserEvents: action.result.loading,
      };
    case DELETE_ROOM: {
      const rooms = state.rooms.concat([]);

      if (action.result.roomId) {
        rooms.splice(findIndex(rooms, { id: action.result.roomId }), 1);
      }

      return {
        ...state,
        loadingRooms: (action.result.loading || !action.result.roomId) && !action.result.error,
        errorDeleteRoom: action.result.error,
        rooms,
      };
    }
    case GET_EVENT_TCS_BY_ID:
      return {
        ...state,
        testCenters: unionBy(state.testCenters, action.result.data || [], 'id'),
        tcLoading: action.result.loading,
      };
    case SET_ROOM_MANUAL_TIMER:
      return {
        ...state,
        manualTimerSet: !isEmpty(action.result.data),
      };
    case GET_TC_INFO:
      return {
        ...state,
        tcInfo: action.result.data,
      };
    case GET_DEVICES_CHECK_COUNT:
      return {
        ...state,
        devicesCheckCount: action.result.data,
      };
    case REVIEW_EVENT_CHECKOUT:
      return {
        ...state,
        currentEvent: action.result.data || {},
      };
    default:
      return state;
  }
}

// Action Creators
export function getTcEventAction(result) {
  return { type: GET_TEST_CENTER_EVENT, result };
}

export function getRoomsAction(result) {
  return { type: GET_ROOMS, result };
}

export function getRoomsDTOAction(result) {
  return { type: GET_ROOMS_DTO, result };
}

export function getTestCenterCycleAction(result) {
  return { type: GET_TEST_CENTER_CYCLE, result };
}

export function getEventsByIdAction(result) {
  return { type: GET_EVENTS_BY_ID, result };
}

export function clearTCEventAction() {
  return { type: GET_TEST_CENTER_EVENT, result: { data: {}, loading: false } }
}

export function clearUserEventsAction() {
  return { type: GET_EVENTS_BY_ID, result: { data: [], loading: false } };
}

export function deleteRoomAction(data) {
  return { type: DELETE_ROOM, result: { loading: data.loading, roomId: data.roomId, error: data.error !== null } };
}

export function getTcsByIdAction(result) {
  return { type: GET_EVENT_TCS_BY_ID, result };
}

export function setRoomManualTimerAction(result) {
  return { type: SET_ROOM_MANUAL_TIMER, result };
}

export function getAllRoomsDTOAction(result) {
  return { type: GET_ALL_ROOMS_DTO, result }
}

export function getTCInfoAction(result) {
  return { type: GET_TC_INFO, result }
}

export function getDevicesCheckCountAction(result) {
  return { type: GET_DEVICES_CHECK_COUNT, result }
}

export function reviewEventCheckoutAction(result) {
  return { type: REVIEW_EVENT_CHECKOUT, result }
}



// Action dispatcher functions

export function getTcEvent(id) {
  return createDispatchFunction(
    partial(TcEventService.getTcEvent, id),
    getTcEventAction
  );
}

export function getRooms(id) {
  return createDispatchFunction(
    partial(TcEventService.getRooms, id),
    getRoomsAction
  );
}

export function getRoomsDTO(eventId) {
  return createDispatchFunction(
    partial(TcEventService.getRoomsDTO, eventId),
    getRoomsDTOAction
  );
}

export function getTestCenterCycle(id) {
  return createDispatchFunction(
    partial(TcEventService.getTestCenterCycle, id),
    getTestCenterCycleAction
  );
}

export function getEventsById(eventIds) {
  return createDispatchFunction(
    partial(TcEventService.getEventsById, eventIds),
    getEventsByIdAction
  );
}

export function getEventTestCentersById(tcIds) {
  return createDispatchFunction(
    partial(TcEventService.getTcsById, tcIds),
    getTcsByIdAction
  );
}

export function deleteRoom(roomId) {
  return createDispatchFunction(
    partial(TcEventService.deleteRoom, roomId),
    deleteRoomAction
  );
}

export function setRoomManualTimer(data) {
  return createDispatchFunction(
    partial(TcEventService.setRoomManualTimer, data),
    setRoomManualTimerAction
  );
}

export function getAllRoomsDTO(eventId) {
  return createDispatchFunction(
    partial(TcEventService.getAllRoomsDTO, eventId),
    getAllRoomsDTOAction
  );
}

export function getTCInfo(eventId) {
  return createDispatchFunction(
    partial(TcEventService.getTCInfo, eventId),
    getTCInfoAction
  );
}

export function getDevicesCheckCount(eventId) {
  return createDispatchFunction(
    partial(TcEventService.getDevicesCheckCount, eventId),
    getDevicesCheckCountAction
  );
}

export function reviewEventCheckout(eventId) {
  return createDispatchFunction(
    partial(TcEventService.reviewEventCheckout, eventId),
    reviewEventCheckoutAction
  );
}
